import React from 'react';
import Reveal from 'react-awesome-reveal';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { connect } from 'react-redux';

import { fadeIn } from '../../../utils/data/keyframes';
import useTranslation from '../../../utils/hooks/useTranslation';

function BrandSection({ partners }) {
    const { t } = useTranslation();
    const { list } = partners;

    if (!list?.length) return null;

    const renderPartner = (partner, copyIndex) => (
        <a
            href={partner.url}
            rel="noopener noreferrer"
            target="_blank"
            className="partner-card"
            key={`partner-${copyIndex}-${partner.id}`}
            aria-label={partner.name}
        >
            <span className="partner-card-image">
                <LazyLoadImage
                    alt={partner.name}
                    src={process.env.REACT_APP_PUBLIC_ASSET_URI + partner.image?.url}
                    threshold={500}
                    effect="opacity"
                />
            </span>
            <span className="partner-card-name">{partner.name}</span>
        </a>
    );

    return (
        <section className="partners-marquee">
            <div className="section-header">
                <span className="section-eyebrow">{t('message.trusted_by')}</span>
                <h2>{t('label.partners')}</h2>
            </div>

            <Reveal keyframes={fadeIn} delay={100} duration={500} triggerOnce>
                <div className="partners-marquee-viewport">
                    <div className="partners-marquee-track">
                        {list.map((p) => renderPartner(p, 'a'))}
                        {list.map((p) => renderPartner(p, 'b'))}
                    </div>
                </div>
            </Reveal>
        </section>
    );
}

const mapStateToProps = (state) => ({
    partners: state.partners
});

export default connect(mapStateToProps, {})(React.memo(BrandSection));
